"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function SecurePayment(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("path", { fill: "#FACE32", d: "M62.663 57.33H1.336A1.333 1.333 0 0 1 .003 56V8.003c0-.736.597-1.333 1.333-1.333h61.327c.736 0 1.333.597 1.333 1.333v47.995c0 .736-.597 1.333-1.333 1.333z" }),
    _react2["default"].createElement("path", { fill: "#FFF", d: "M.003 30.667H6.67v2.666H.002zm57.327 0h6.667v2.666H57.33zM20.125 6.67a27.963 27.963 0 0 0-10.64 8.685l-.4.54H0V13.23h7.753a30.36 30.36 0 0 1 6.993-6.56h5.38zM64 13.242v2.666h-9.08l-.4-.54a27.997 27.997 0 0 0-10.638-8.7h5.36c2.645 1.794 5.025 4 7.018 6.574H64zM20.038 57.33h-5.34a30.767 30.767 0 0 1-6.425-5.905H0V48.76h9.56l.4.506a28.028 28.028 0 0 0 10.078 8.065zm43.955-9.225v2.666h-7.746a30.34 30.34 0 0 1-6.993 6.56h-5.38a27.963 27.963 0 0 0 10.64-8.686l.4-.54h9.08z" }),
    _react2["default"].createElement("path", { d: "M17.335 22.668h-6v18.665h4v-6.666h2a6 6 0 0 0 0-12zm2 6.332c0 .92-.747 1.666-1.666 1.666h-2.334v-4h2.333c.92 0 1.665.747 1.665 1.666V29zm34.663-6.332L48.665 34v7.332h-4V34l-5.332-11.332H43.6l3.05 6.832 3.013-6.832zM38.44 38l-.714-2.667-.36-1.333-3.033-11.332h-4.666L26.634 34l-.36 1.333L25.56 38l-.892 3.332h4l.82-3.333h5.026l.82 3.332h4L38.44 38zm-6.446-10.233L33.527 34h-3.06l1.527-6.233z", fill: "#55A344" })
  );
}

exports["default"] = SecurePayment;
module.exports = exports["default"];